/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Content_Section_TitleInputs */

const en_course_content_section_title = /** @type {(inputs: Course_Content_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Course content`)
};

const ja_course_content_section_title = /** @type {(inputs: Course_Content_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コース内容`)
};

const fr_course_content_section_title = /** @type {(inputs: Course_Content_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu du cours`)
};

const de_course_content_section_title = /** @type {(inputs: Course_Content_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kursinhalt`)
};

/**
* | output |
* | --- |
* | "Course content" |
*
* @param {Course_Content_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_content_section_title = /** @type {((inputs?: Course_Content_Section_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Content_Section_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_content_section_title(inputs)
	if (locale === "ja") return ja_course_content_section_title(inputs)
	if (locale === "fr") return fr_course_content_section_title(inputs)
	return de_course_content_section_title(inputs)
});